// Add calendly iframe with correct link based on email from url params
document.addEventListener('DOMContentLoaded', async () => {
    // Get tool container where the iframe will go
    const container = document.getElementById('tool-target');
    if (!container) return;

    // Show loading spinner
    showLoadingSpinner(container);

    // Build email param from hashed email in url params
    const urlParams = new URLSearchParams(window.location.search);
    let email = '';
    const hashedEmail = urlParams.get('email') || '';
    try { if (hashedEmail) email = atob(hashedEmail); } catch { }

    // set default link 
    const defaultLink = document.querySelector('.ec-block[data-ec-view="tool"]').dataset.defaultToolLink || 'https://17squares.com/modularClosets';
    let recipeLink = defaultLink;

    // Get recipe link using email
    try {
        const res = await fetch(
            `https://clkt6aj418.execute-api.us-east-2.amazonaws.com/prod/query?template=get_recipe&user_email=${email}`,
            // `https://clkt6aj418.execute-api.us-east-2.amazonaws.com/prod/ - to see documentation. Yitz Neumann made the api`,
            {
                method: 'GET',
                headers:
                {
                    'x-api-key': 'QU4AGl-tMCRl1w8gjDs3cAE34KugkmgtE7QNv7nHU8M'
                }
            }
        );
        const data = await res.json();
        if (data?.Recipe_Link__c) recipeLink = data.Recipe_Link__c;
        // console.log('Tool API recipe link:', recipeLink);
    } catch (e) {
        console.warn('API error, using fallback:', e);
    }

    console.log('Final recipe link to use:', recipeLink);

    // Show correct description based on recipe link
    const isRecipe = recipeLink != defaultLink;
    document.querySelector('.ec-recipe-description').style.display = isRecipe ? 'block' : 'none';
    document.querySelector('.ec-non-recipe-description').style.display = isRecipe ? 'none' : 'block';

    // Dead code: nothing sets it
    // if came directly after booking calendly, change heading
    // const fromCalendly = urlParams.get('booked') === 'true';
    // if (fromCalendly) {
    //     const heading = document.querySelector('.ec-heading');
    //     if (heading) heading.textContent = 'Your meeting was booked!';
    // }

    // Load the tool iframe
    mountToolIframe(container, recipeLink);

    function showLoadingSpinner(parent) {
        parent.innerHTML = `
            <div class="calendly-loading">
                <span id="rotating-text">Great closets take a moment…...</span>
                <div class="spinner"></div>            
            </div>
        `;
        const messages = [
            'Great closets take a moment...',
            'Hold your hangers — we’re getting organized...',
            'Zipping up the final details...',
            'Almost there — your dream closet awaits...'
        ];
        let i = 0;
        const textEl = parent.querySelector('#rotating-text');
        parent._spinnerInterval = setInterval(() => {
            i = (i + 1) % messages.length;
            if (textEl) textEl.textContent = messages[i];
        }, 2000);
    }


    function mountToolIframe(parent, url) {
        // Insert iframe and fullscreen buttons
        parent.innerHTML = `
            <button class="open-fullscreen">Open Full Screen</button>
            <iframe id="tool-iframe" src="${url}" width="100%" height="700" referrerPolicy="no-referrer-when-downgrade" style="opacity:0; transition: opacity .25s ease;"></iframe>
            <button class="close-fullscreen" id="closeFullscreen">Close Full Screen</button>
        `;

        const iframe = document.getElementById('tool-iframe');
        const openBtn = parent.querySelector(".open-fullscreen");
        const closeBtn = document.getElementById("closeFullscreen");

        // Fullscreen button handlers
        openBtn.addEventListener("click", () => {
            iframe.classList.add("iframe-fullscreen");
            closeBtn.style.display = "block";
            document.body.style.overflow = "hidden";
        });

        closeBtn.addEventListener("click", () => {
            iframe.classList.remove("iframe-fullscreen");
            closeBtn.style.display = "none";
            document.body.style.overflow = "";
        });

        // Reveal iframe on load
        const reveal = () => {
            clearInterval(parent._spinnerInterval);
            parent.querySelector('.calendly-loading')?.remove();
            iframe.style.opacity = '1';
        };

        iframe.addEventListener('load', reveal, { once: true });

        // safety fallback if 'load' never fires
        const safety = setTimeout(reveal, 8000);
        iframe.addEventListener('load', () => clearTimeout(safety), { once: true });
    }
});
